import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDebounce } from "../../utils/customHook.util";
import { Flex } from "../Common/Flex";
import Icon from "../Common/Icon";
import "../Common/SearchFilter.css";

const MINIMUM_SEARCH_LENGTH = 3;

type MembersSearchFilterProps = {
    className?: string;
    total: number;
    onChange: (search: string | undefined) => void;
};

export function MembersSearchFilter({
    className,
    total,
    onChange,
}: MembersSearchFilterProps) {
    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm.trim(), 200);
    const activeSearch =
        debouncedSearchTerm.length >= MINIMUM_SEARCH_LENGTH
            ? debouncedSearchTerm
            : undefined;

    useEffect(() => {
        onChange(activeSearch);
    }, [activeSearch, onChange]);

    return (
        <div className={classNames("search-filter", className)}>
            <Icon.Search.Small className="search-filter__icon" />
            <input
                type="text"
                value={searchTerm}
                placeholder="Search by name, phone, email, or location"
                onChange={(event) => setSearchTerm(event.target.value)}
            />
            {activeSearch ? (
                <Flex.Row
                    className="search-filter__matches"
                    justifyContent="end"
                    onClick={() => setSearchTerm("")}
                >
                    <span>{`${total} match${total === 1 ? "" : "es"}`}</span>
                    <div>
                        <Flex.Row>
                            <Icon.Close.Small />
                        </Flex.Row>
                    </div>
                </Flex.Row>
            ) : null}
        </div>
    );
}
